import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme, THEMES } from '../contexts/ThemeContext';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const ThemeToggle = ({ className = '' }) => {
  const { theme, setTheme, resolvedTheme } = useTheme();

  const getIcon = () => {
    if (theme === THEMES.AUTO) {
      return <Monitor className="w-5 h-5" />;
    }
    return resolvedTheme === THEMES.DARK 
      ? <Moon className="w-5 h-5" /> 
      : <Sun className="w-5 h-5" />;
  };

  const getLabel = () => {
    switch (theme) {
      case THEMES.LIGHT:
        return 'Claro';
      case THEMES.DARK:
        return 'Escuro';
      case THEMES.AUTO:
        return 'Automático';
      default:
        return 'Tema';
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="outline" 
          size="sm" 
          className={`gap-2 theme-toggle-btn ${className}`}
          data-testid="theme-toggle-btn"
        >
          {getIcon()}
          <span className="hidden sm:inline">{getLabel()}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="theme-dropdown">
        <DropdownMenuItem 
          onClick={() => setTheme(THEMES.LIGHT)}
          className={`gap-2 cursor-pointer ${theme === THEMES.LIGHT ? 'bg-primary/10' : ''}`}
          data-testid="theme-light-option"
        >
          <Sun className="w-4 h-4 text-yellow-500" />
          <span>Claro</span>
          {theme === THEMES.LIGHT && <span className="ml-auto text-primary">✓</span>}
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => setTheme(THEMES.DARK)}
          className={`gap-2 cursor-pointer ${theme === THEMES.DARK ? 'bg-primary/10' : ''}`}
          data-testid="theme-dark-option"
        >
          <Moon className="w-4 h-4 text-indigo-500" />
          <span>Escuro</span>
          {theme === THEMES.DARK && <span className="ml-auto text-primary">✓</span>}
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => setTheme(THEMES.AUTO)}
          className={`gap-2 cursor-pointer ${theme === THEMES.AUTO ? 'bg-primary/10' : ''}`}
          data-testid="theme-auto-option"
        >
          <Monitor className="w-4 h-4 text-slate-500" />
          <span>Automático</span>
          {theme === THEMES.AUTO && <span className="ml-auto text-primary">✓</span>}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ThemeToggle;
